var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXItemsForYBundleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 6,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6693 19.3359C20.8283 19.3359 19.3359 20.8283 19.3359 22.6693V34.3359C19.3359 36.1769 20.8283 37.6693 22.6693 37.6693H49.3359C51.1769 37.6693 52.6693 36.1769 52.6693 34.3359V22.6693C52.6693 20.8283 51.1769 19.3359 49.3359 19.3359H22.6693ZM36.0026 32.6693C38.3038 32.6693 40.1693 30.8038 40.1693 28.5026C40.1693 26.2014 38.3038 24.3359 36.0026 24.3359C33.7014 24.3359 31.8359 26.2014 31.8359 28.5026C31.8359 30.8038 33.7014 32.6693 36.0026 32.6693Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6693 43.5026C52.6693 44.4231 51.9231 45.1693 51.0026 45.1693H21.0026C20.0821 45.1693 19.3359 44.4231 19.3359 43.5026C19.3359 42.5821 20.0821 41.8359 21.0026 41.8359H51.0026C51.9231 41.8359 52.6693 42.5821 52.6693 43.5026Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0026 52.6693C51.9231 52.6693 52.6693 51.9231 52.6693 51.0026C52.6693 50.0821 51.9231 49.3359 51.0026 49.3359H21.0026C20.0821 49.3359 19.3359 50.0821 19.3359 51.0026C19.3359 51.9231 20.0821 52.6693 21.0026 52.6693H51.0026Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXItemsForYBundleIcon);
export default __webpack_public_path__ + "static/media/x-items-for-y-bundle-icon.4714468b008e6428557cdadb006a14a5.svg";
export { ForwardRef as ReactComponent };